<template>
  <div>
    <v-alert
      v-if="answer.isOutdated"
      dense
      text
      color="primary"
      class="mt-4"
    >
      <v-row align="center">
        <v-col class="shrink">
          <v-icon color="primary">
            mdi-information-outline
          </v-icon>
        </v-col>
        <v-col class="grow">
          Question updated after the answer was submitted
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>
<script>
export default {
  name: 'CandidateAnswerOutdatedComponent',
  props: {
    answer: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    //
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    //
  }
}
</script>
